export const getPublishers = (state) => state.publisher.publishers;
export const getSelectedFilter = (state) => state.publisher.selectedFilter;
